import OrgChart from '../../../../assets/orgchart/orgchart';
import { useEffect } from 'react';
import { UserNode } from '../../models/UserNode';
import React from 'react';
import useElementSize from '../../hooks/elementSize-hooks';
interface IProps {
	nodes: UserNode[];
}

export const ChartComponent = (props: IProps) => {
	const height = useElementSize("chart");
	const style = {
		height: height + 'px',
		width: '100%',
	};
	const configChart = () => {

		OrgChart.SEARCH_PLACEHOLDER = "Búsqueda";

		// Corporative template
		OrgChart.templates.GCOTemplate = Object.assign({}, OrgChart.templates.ana);
		OrgChart.templates.GCOTemplate.size = [277, 88];
		OrgChart.templates.GCOTemplate.node = '<rect x="0" y="0" height="{h}" width="{w}" fill="#ffffff" stroke-width="1" stroke="#E6E6E6"></rect><line x1="0" y1="2.5" x2="277" y2="2.5" stroke-width="5" stroke="#DC0028"></line>';

		OrgChart.templates.GCOTemplate.field_0 = '<text class="field_0" width="180" data-width="180" data-text-overflow="ellipsis" style="font-size: 16px;" font-weight="bold" fill="#646464" x="86" y="38" text-anchor="start">{val}</text>';
		OrgChart.templates.GCOTemplate.field_1 = '<text class="field_1" width="166" data-width="166" data-text-overflow="ellipsis" style="font-size: 12px;" font-weight="regular" fill="#646464" x="86" y="58" text-anchor="start">{val}</text>';

		OrgChart.templates.GCOTemplate.img_0 =
			'<clipPath id="{randId}">' +
			'<circle cx="45" cy="45" r="30"></circle>' +
			'</clipPath>' +
			'<circle cx="45" cy="45" r="30" fill="#f0f0f0"></circle>' +
			'<image preserveAspectRatio="xMidYMid slice" clip-path="url(#{randId})" xlink:href="{val}" x="15" y="15" width="60" height="60">' +
			'</image>';

		OrgChart.templates.GCOTemplate.nodeMenuButton = '<g style="cursor:pointer;" transform="matrix(1,0,0,1,240,77)" control-node-menu-id="{id}"><rect x="-4" y="-50" fill="#000000" fill-opacity="0" width="22" height="22"></rect><circle cx="4" cy="0" r="2" fill="#B3B3B3"></circle><circle cx="9" cy="0" r="2" fill="#B3B3B3"></circle><circle cx="14" cy="0" r="2" fill="#B3B3B3"></circle></g>';

		OrgChart.templates.GCOTemplate.minus =
			'<circle cx="15" cy="15" r="13" fill="#fff" stroke="#B3B3B3" stroke-width="1"></circle>' +
			'<line x1="11" y1="15" x2="19" y2="15" stroke-width="1.5" stroke="#B3B3B3"></line>';
		OrgChart.templates.GCOTemplate.plus =
			'<circle cx="15" cy="15" r="13" fill="#ffffff" stroke="#B3B3B3" stroke-width="1"></circle>' +
			'<line x1="11" y1="15" x2="19" y2="15" stroke-width="1.5" stroke="#B3B3B3"></line><line x1="15" y1="11" x2="15" y2="19" stroke-width="1.5" stroke="#B3B3B3"></line>';

		OrgChart.templates.GCOTemplate.editFormHeaderColor = '#DC0028';
		OrgChart.templates.GCOTemplate.menuButton = '<div style="position:absolute;right:{p}px;top:{p}px; width:40px;height:50px;cursor:pointer" data-ctrl-menu="">' + '<img src="download.png" style="max-width:28px">' + '</div>';

		// Dashed line template 
		OrgChart.templates.GCOTemplateDashed = Object.assign({}, OrgChart.templates.GCOTemplate);
		OrgChart.templates.GCOTemplateDashed.link = '<path stroke-dasharray="6, 4" stroke-linejoin="round" stroke="#B3B3B3" stroke-width="1px" fill="none" d="M{xa},{ya} {xb},{yb} {xc},{yc} L{xd},{yd}" />';
		OrgChart.templates.GCOTemplateDashed.editFormHeaderColor = '#ff6961';
		OrgChart.templates.GCOTemplateDashed.node = 
		'<rect x="0" y="0" height="{h}" width="{w}" fill="#f8f8f8" stroke-dasharray="3" stroke-width="1" stroke="#B3B3B3"></rect>';

		// Red light template 
		OrgChart.templates.GCOTemplateLight = Object.assign({}, OrgChart.templates.GCOTemplate);
		OrgChart.templates.GCOTemplateLight.editFormHeaderColor = '#ff6961';
		OrgChart.templates.GCOTemplateLight.node =
			'<rect x="0" y="0" height="{h}" width="{w}" fill="#ffffff" stroke-width="1" stroke="#E6E6E6"></rect><line x1="0" y1="2.5" x2="277" y2="2.5" stroke-width="5" stroke="'
			+ OrgChart.templates.GCOTemplateLight.editFormHeaderColor
			+ '"></line>';
			OrgChart.templates.GCOTemplateLight.link = '<path stroke-dasharray="6, 4" stroke-linejoin="round" stroke="#B3B3B3" stroke-width="1px" fill="none" d="M{xa},{ya} {xb},{yb} {xc},{yc} L{xd},{yd}" />';


		// Grey template 
		OrgChart.templates.GCOTemplateGrey = Object.assign({}, OrgChart.templates.GCOTemplate);
		OrgChart.templates.GCOTemplateGrey.editFormHeaderColor = '#b3b3b3';
		OrgChart.templates.GCOTemplateGrey.node =
			'<rect x="0" y="0" height="{h}" width="{w}" fill="#ffffff" stroke-width="1" stroke="#E6E6E6"></rect><line x1="0" y1="2.5" x2="277" y2="2.5" stroke-width="5" stroke="'
			+ OrgChart.templates.GCOTemplateGrey.editFormHeaderColor
			+ '"></line>';
		OrgChart.templates.GCOTemplateGrey.node = '<rect x="0" y="0" height="{h}" width="{w}" fill="#f8f8f8" stroke-width="1" stroke="#B3B3B3"></rect>';


		rewriteSearchAndComputeScore();
	};

	const NormalizeString = (t: string | string[]): string | string[] => {
		// if t is array
		if (Array.isArray(t)) {
			var e = [];
			for (var r in t)
				e.push(NormalizeString(t[r]) as string);
			return e;
		}

		// if t is string
		return t.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
	}

	const rewriteSearchAndComputeScore = () => {
		(OrgChart as any)._search.searchAndComputeScore = function (t:any, e:any, r:any, i:any) {
			if (OrgChart.isNEU(e))
				return null;
			if (OrgChart.isNEU(t))
				return null;
			if (!t.length)
				return null;
			"string" != typeof e && (e = e.toString());
			var a = e.toLowerCase()
				, n = (OrgChart as any)._search.searchIndexesOf(NormalizeString(a), NormalizeString(t));
			if (!n.length)
				return null;
			for (var o = a.length / 100, l = 0, s = 0, h = l > 0 ? 100 : 0, c = 0, d = 0; d < t.length; d++)
				for (var g = t[d], p = 0; p < n.length; p++)
					if (-1 != g.indexOf(n[p].searchPhrase)) {
						c++;
						break
					}
			var u = 100 / (t.length / c);
			if (n.length) {
				s = n[0].start;
				for (p = 0; p < n.length; p++)
					if (l += n[p].length,
						n[p].start < s && (s = n[p].start),
						p >= 1 && n[p - 1].start > n[p].start) {
						h = 0;
						break
					}
			}
			var f = 0;
			0 != l && (f = l / o);
			var m = l > 0 ? 100 : 0;
			0 != s && (m = 100 - s / o);
			var C = 0;
			i && i[r] && (C = i[r]),
				u && (u = u / 100 * 50),
				f > 0 && (f = f / 100 * 10),
				m > 0 && (m = m / 100 * 10),
				h > 0 && (h = h / 100 * 10),
				C > 0 && (C = C / 100 * 20);
			var b = Math.round(1e4 * (u + f + m + h + C));
			n.sort((function (t:any, e:any) {
				return t.start < e.start ? -1 : t.start > e.start ? 1 : 0;
			}
			));
			var O = e;
			for (p = n.length - 1; p >= 0; p--)
				O = (O = O.insert(n[p].start + n[p].length, "</mark>")).insert(n[p].start, "<mark>");
			return {
				__searchMarks: O,
				__score: b
			}
		}
    }

	useEffect(() => {
		//Declaracion de las plantillas

		const chartElement = document.getElementById('chart');
		if (chartElement === null) return;

		configChart();

		const orgChartData = new OrgChart(chartElement, {
			template: 'GCOTemplate',
			nodes: props.nodes,
			layout: OrgChart.tree,
			levelSeparation: 100,
			siblingSeparation: 50,
			subtreeSeparation: 50,
			mixedHierarchyNodesSeparation: 30,
			collapse: {
				level: 1,
				allChildren: true,
			},
			//mouseScrool: OrgChart.none, Defineix el comportament de la roda del ratol�
			editForm: {
				generateElementsFromFields: false,
				elements: [
					{ type: 'textbox', label: 'Nombre', binding: 'Nombre' },
					{ type: 'textbox', label: 'Código Empleado', binding: 'Número de empleado' },
					{ type: 'textbox', label: 'Rol', binding: 'Descripción del rol' },
					{ type: 'textbox', label: 'Código INFO', binding: 'Código INFO' },
					{ type: 'textbox', label: 'Teléfono', binding: 'Teléfono' },
					{ type: 'textbox', label: 'Móvil', binding: 'Móvil' },
					{ type: 'textbox', label: 'Compañía', binding: 'Compañía' },
					{ type: 'textbox', label: 'Email', binding: 'Email' },
					{ type: 'textbox', label: 'Ubicación Oficina', binding: 'Ubicación Oficina' },
					{ type: 'textbox', label: 'Dirección', binding: 'Dirección' },
				],
				buttons: {
					edit: null,
					share: null,
					pdf: null,
					remove: null
				}
			},
			searchFields: [ //Propiedades por las que buscar
				'Nombre',
				'Número de empleado',
				'Descripción del rol',
				'Código INFO',
				//  'Teléfono',
				//  'Móvil',
				//  'Compañía',
				//  'Email'
			],
			searchDisplayField:"Nombre", //Muestra siempre el nombre en las búsquedas
			menu: {
				png: { text: 'Exportar a PNG' },
			},
			showYScroll: true,
			showXScroll: true,
			toolbar: {
				zoom: true,
				fit: true,
			},
			nodeBinding: {
				field_0: 'Nombre',
				field_1: 'Descripción del rol',
				img_0: 'img',
			},
			tags: {
				'NotRepeated': { template: 'GCOTemplate' },
				'Repeated': { template: 'GCOTemplateGrey' },
				'assistant': { template: 'GCOTemplateLight' }
			}
		});

		orgChartData.on('expcollclick', function (sender, collapse, id) {
			if (!collapse) {
				sender.center(id, {
					parentState: OrgChart.COLLAPSE_PARENT_NEIGHBORS,
					childrenState: OrgChart.COLLAPSE_SUB_CHILDRENS,
					rippleId: id,
					vertical: true,
					horizontal: true
				});
			} else {
				sender.collapse(id, sender.getNode(id as string | number).childrenIds as (string | number)[]);
				return false;
			}
			return false;
		});

		orgChartData.on(
			'searchclick',
			function (sender: OrgChart, args: string | number) {
				sender.center(args, {
					parentState: OrgChart.COLLAPSE_PARENT_NEIGHBORS,
					childrenState: OrgChart.COLLAPSE_SUB_CHILDRENS,
					rippleId: args,
					vertical: true,
					horizontal: true
				});
				orgChartData.collapse(args, orgChartData.getNode(args).childrenIds as (string | number)[]);
				orgChartData.searchUI.hide();
				return false;
			}
		);
	}, []);

	return <div style={style} id="chart"></div>;
};


